"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
exports.SUBREGION_CODES = [
    'US_CON',
    'US_AK',
    'US_HI',
    'US_PR',
    'US_OTHER',
];
function subregionName(regionCode) {
    return I18n.t("commons.subRegions." + regionCode);
}
exports.subregionName = subregionName;
function shippingRegionName(regionCode, countries) {
    if (lodash_1.includes(exports.SUBREGION_CODES, regionCode)) {
        return subregionName(regionCode);
    }
    return countries.find(function (country) { return country.countryCode === regionCode; }).name;
}
exports.shippingRegionName = shippingRegionName;
function isUSSubregion(regionCode) {
    return lodash_1.includes(exports.SUBREGION_CODES, regionCode);
}
exports.isUSSubregion = isUSSubregion;
//# sourceMappingURL=shipping_region.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/shipping_region.js
// module id = lkmN
// module chunks = 20 21